import { create } from "zustand";
import { persist } from "zustand/middleware";

type PrivacyMaskStore = {
  enabled: boolean;
  toggle: () => void;
};

/**
 * "Hide sensitive data" switch (the eye on report pages). Persisted so it
 * survives navigation and reloads while presenting a screen. Only honoured
 * for users with read:back-office; see usePrivacyMask.
 */
export const usePrivacyMaskStore = create<PrivacyMaskStore>()(
  persist(
    set => ({
      enabled: false,
      toggle: () => set(state => ({ enabled: !state.enabled })),
    }),
    { name: "privacy-mask" }
  )
);
